import { Section } from '@/pages/CompanyReport/components/Overview/components/Section';
import { SubSectionHeader } from '@/pages/CompanyReport/components/Overview/components/SubSectionHeader';
import { Ratios } from './components/Ratios';
import Dividends from './components/Dividends';
import { HorizontalRule } from './styled';
import { IncomeStatement } from '@/pages/CompanyReport/components/Overview/components/Fundamentals/components/IncomeStatement';
import { useDwellTracking } from '@/pages/CompanyReport/components/DwellTrackingProvider';
import { useReportSection } from '@/pages/CompanyReport/components/ReportSectionProvider';
import { useOverviewTranslation } from '@/pages/CompanyReport/components/OverviewSection/hooks/useOverviewTranslation';

interface Props {
  name: string;
}
export function Fundamentals({ name }: Props) {
  const { observe } = useDwellTracking();
  const { section } = useReportSection();
  const t = useOverviewTranslation();

  return (
    <Section data-cy-id="fundamentals-summary-section" data-section={section}>
      <div
        data-cy-id="fundamentals_ratios"
        data-section={section}
        ref={observe}
      >
        <SubSectionHeader>
          {t('fundamentals.heading', { name })}
        </SubSectionHeader>
        <Ratios />
        <HorizontalRule />
      </div>
      <div
        data-cy-id="fundamentals_income_statement"
        data-section={section}
        ref={observe}
      >
        <IncomeStatement />
      </div>
      <div
        data-cy-id="fundamentals_dividends"
        data-section={section}
        ref={observe}
      >
        <Dividends />
      </div>
    </Section>
  );
}
